import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=2ad8e9fb&scoped=true"
import script from "./Incoming.vue?vue&type=script&lang=js"
export * from "./Incoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8e9fb",
  null
  
)

export default component.exports